import classNames from 'classnames';
import { format } from 'date-fns';
import { Badge, Heading } from 'yoso';
import { BaseCard } from '~/components/Card';
import heroStyles from '~/components/Hero/Hero.module.scss';
import { T } from '~/components/I18n';
import { useLandEvent } from '~/components/Land/Event';
import { DescriptionList } from '~/components/List/Description/DescriptionList';
import type { LandEventHeroProps } from '../LandEventHero';
import styles from '../LandEventHero.module.scss';

export const EndedLandEventHero = ({ id, className }: LandEventHeroProps) => {
  const {
    data: { week, announcedAt },
  } = useLandEvent(id);

  return (
    <BaseCard className={classNames(heroStyles.root, styles.root, className)} size="large">
      <Badge className={heroStyles.badge} color="default">
        <T name="citizen_event_status_end" />
      </Badge>
      <Heading level={3} className={heroStyles.heading}>
        <T name="citizen_land_end_title" options={[week]} />
      </Heading>
      <DescriptionList layout="responsive" className={heroStyles.sublist}>
        <dt>
          <T name="citizen_land_announcement_date" />
        </dt>
        <dd>{format(announcedAt, 'P p')}</dd>
      </DescriptionList>
    </BaseCard>
  );
};
